import { Box } from '@chakra-ui/react';

import { DmpItem, UserInfo } from '@app/api/models';
import { FieldView } from '@app/components/common';
import { TableColumn, dateTimeBodyRender } from '@app/components/common/table';
import GalleryModal from '@app/components/common/modals/gallery';

export const standsColumns: TableColumn<DmpItem>[] = [
  {
    name: 'id',
    label: 'ID',
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: 'visit_date',
    label: 'Дата визита',
    options: {
      filter: {
        type: 'date',
        name: 'visit_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'id',
    label: 'ДМП',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, { rowData }) => {
        return <Box display='flex' gap={0} flexDirection='column'>
          <FieldView title="Тип" value={rowData.type.name} direction='row' />
          <FieldView title="Тип" value={rowData.type.name} direction='row' />
        </Box>;
      }
    }
  },
  {
    name: 'update_dt',
    label: 'Дата обновления',
    options: {
      filter: false,
      sort: false,
      customBodyRender: dateTimeBodyRender(),
    }
  },
  {
    name: 'images',
    label: 'Фото',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<any>) => {
        return <GalleryModal  images={value || []} title="Фото" />;
      },
    },
  },
  {
    name: 'user',
    label: 'Пользователь',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: UserInfo, { rowData }) => {
        return <>{value?.full_name}</>;
      },
    },
  },
];